module.exports = __webpack_public_path__ + "img/payment.b9d4ebfe.svg";